import React, { useEffect, useState } from 'react';
import csvIcon from 'src/assets/images/csv.svg'
import excelIcon from 'src/assets/images/xls.svg'
import Helper from 'src/helper/Helper';
import Quote from "@system/config/quote";
import { useQuoteStore } from 'src/hooks/quote';
import Constants from 'src/helper/Constants';
import System from 'src/helper/system';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import buyerquote from "src/assets/images/buyer-quote.svg";
import phonequote from "src/assets/images/phone-quote.svg";
import emailquote from "src/assets/images/email-quote.svg";
import HelperAdobeEvent from "src/support/HelperAdobeEvent";

const c = System.getParams();

export function CustomerInformation(props) {
    const [{ submittedQuoteList }, { fetch_submitted_quote_export_url }, { }] = useQuoteStore();
    const [data, setData] = useState({})
    const [__check] = useAxiosIndicatorCheck();
    const isCoreUser = System.avUserInfoData.currentUser === Constants.siteUser.CORE

    useEffect(() => {
        if (submittedQuoteList?.records?.length > 0) {
            setData(submittedQuoteList?.records[0])
        }
    }, [submittedQuoteList])

    const exportQuote = async (fileType) => {
        let res = {
            "quoteNumber": c?.quote_number,
            "fileType": fileType,
            "quoteExpirationDate": Helper.valueIsNotNull(data?.quoteExpirationDate) ? Helper.convertDateFormatToMMDDYYYY(data.quoteExpirationDate) : null,
            "customerQuoteNumber": Helper.valueIsNotNull(data?.customerQuoteNumber) ? data.customerQuoteNumber : null
        }
        await fetch_submitted_quote_export_url(res)
        exportEvent(fileType)
    };


    //By Ramya [Export Event - Cart ADobe script]
  function exportEvent(type){
    localStorage.setItem("adobeEventType","exportEvent");
    let exportDetails = {
      fileExtension : type,
      exportType: "Quote"
    }
    let QuoteDetails = {
        quoteID:data.quoteNumber,
        quoteType:data.quoteSource
    };
    if(Object.keys(exportDetails).length && Object.keys(QuoteDetails).length) {
        HelperAdobeEvent.trackingAdobeEvent({QuoteDetails,exportDetails});
    }

  }

    return (
        <>
            <div className="pcn-line-divider"> </div>
            <a href={Quote.getSubmittedQuoteAbsoluteUrl()}>Submitted Quote </a>
            {__check(['QUOTE_API_CALL']).status ? __check(["QUOTE_API_CALL"]).render :
                <div className="customer-info">
                    <div className='customer-info-wrapper'>
                        <div className="bs5 row">
                            <div className="col-7">
                                <h2 className='page-heading mt-0 mb-3 font-18'>Customer Information</h2>

                            </div>
                            <div className="col-5 text-right">
                                <div className="d-inline-flex flex-column align-items-end">
                                    <p className="date-requested"><i> Date requested: {data?.quoteRequestedDate && Helper.dateFormatFromString(data?.quoteRequestedDate)} | Expiration:
                                        {data?.quoteExpirationDate ? Helper.dateFormatFromString(data?.quoteExpirationDate) : '----'}</i></p>

                                </div>
                            </div>
                            <div className='col-12'>
                                <ul className="list-inline mb-3">
                                    <li className='me-4'><b>
                                        <img className="me-1 mb-1" height={13} src={buyerquote} /> Buyer: </b> &nbsp; {data?.buyer || Constants.noValue}
                                    </li>
                                    <li className='me-4'><b>
                                        <img className="me-1 mb-1" src={phonequote} /> Phone: </b> &nbsp; {data.contactPhone || Constants.noValue}
                                    </li>
                                    <li className='me-4'><b>
                                        <img className="me-1 mb-1" src={emailquote} /> Email: </b> &nbsp; {data?.contactEmail || Constants.noValue}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className='quote-info-wrapper'>
                        <div className="bs5 row">
                            <div className="col-7">
                                <h2 className='page-heading mt-0 font-18'>Quote Information</h2>
                                <div>
                                    <div className='font-arial font-13'>
                                        <strong>Ships To:</strong>
                                        <span className='font-arial font-12'> {(isCoreUser ? data?.shipToCustomerName : (data?.shipToCustomerName + 
                                         ', ' + (data?.shipToAddress?.length > 0 && Object.values(data?.shipToAddress?.[0]).filter(obj => obj !== null).join(', ')))) || Constants.noValue}</span>
                                    </div>

                                    <div className='font-arial font-13'>
                                        <strong>Project Name:</strong>
                                        <span className='font-arial font-12'> {data?.projectName ? data.projectName : Constants.noValue}</span>
                                    </div>
                                    <div className='font-arial font-13'>
                                        <strong>Originated:</strong>
                                        <span className='font-arial font-12'> {data?.originated ? data.originated : Constants.noValue}</span>
                                    </div>
                                    <div className='font-arial font-13'>
                                        <strong>Customer Quote Number:</strong>
                                        <span className='font-arial font-12'> {data?.customerQuoteNumber ? data.customerQuoteNumber : Constants.noValue}</span>
                                    </div>
                                </div>

                            </div>
                            <div className="col-5 text-right">
                                <div className="d-inline-flex flex-column align-items-end">

                                    <h2 className="page-heading mt-0 font-16">Export/Download Quote</h2>
                                    <ul className="list-inline">
                                        {__check('EXPORT_URL', { inline: true }).render}
                                        {!__check(['EXPORT_URL']).status &&
                                            <>
                                                <li><a className="customer-link bs5 d-flex align-items-center" href={void (0)}><i><img src={csvIcon} /></i>
                                                    <span className="bs5 text-blue pt-1" onClick={() => exportQuote('csv')}>CSV</span>
                                                </a></li>
                                                <li><a className="customer-link bs5 d-flex align-items-center" href={void (0)}><i><img src={excelIcon} alt='Export/Download XLSX' /></i>
                                                    <span className="bs5 text-blue pt-1" onClick={() => exportQuote('xlsx')}>XLSX</span>
                                                </a></li>
                                            </>
                                        }
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    );

}
